import React, {Component} from 'react'
import {connect} from 'react-redux'
import {change} from 'redux-form'
import moment from 'moment'

import SostaOnlineApiService from '../../services/SostaOnlineApiService'
import UserArea from './UserArea'

const fileDownload = require('js-file-download')

const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

class UserAreaContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      // userId: props.match.params.id,
      userType: {},
      userTypes: [],
      user: {},
      areas: [],
      parkingPassTypes: [],
      markTypes: [],
      parkTicketTypes: [],
      vehicleLoading: false,
      vehicleError: null,
      vehicleSuccess: false,
      markLoading: false,
      markError: null,
      markSuccess: false,
      parkTicketLoading: false,
      parkTicketError: null,
      parkTicketSuccess: false,
      receiptLoading: false,
      receiptError: null,
      receiptSuccess: false,
      vehiclesEditsResults: {},
      vehiclesDeleteResults: {},
      marksDeleteResults: {},
      marksCeaseResults: {},
      renewErrors: null,
      showRenewMarkModal: false,
      renewingMark: null,
      userAdjustment: null,
      merger: null,
      merging: false
    }

    this.onOpenRenewMarkModal = this.onOpenRenewMarkModal.bind(this)
    this.onCloseRenewMarkModal = this.onCloseRenewMarkModal.bind(this)
    this.onRenewMark = this.onRenewMark.bind(this)
    this.fetchAdjustment = this.fetchAdjustment.bind(this)
    this.fetchMerger = this.fetchMerger.bind(this)
    this.onAdjustmentPay = this.onAdjustmentPay.bind(this)
    this.onMergeConfirm = this.onMergeConfirm.bind(this)
    this.onMergeRefuse = this.onMergeRefuse.bind(this)
  }

  componentWillMount () {
    this.fetchUser()
    this.fetchAreas()
    // this.fetchUserTypes();
    // this.fetchParkingPassTypes();
    this.fetchParkTicketTypes()
  }

  onVehicleSubmit (data) {
    this.setState({vehicleLoading: true, vehicleError: null, vehicleSuccess: false})
    let obj = {
      plateNumber: data.plateNumber,
      type: data.type
    }
    SostaOnlineApiService.createVehicleMe(obj).then(result => {
      this.setState({vehicleLoading: false, vehicleError: null, vehicleSuccess: true})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nella creazione del veicolo'
      if (err.error === 'Plate already exists') {
        error = 'Errore! Targa già esistente!'
      }
      this.setState({vehicleLoading: false, vehicleError: error, vehicleSuccess: false})
    })
  }

  onCloseVehicleEdit () {
    this.fetchUser()
    this.setState({vehiclesEditsResults: {}})
  }

  onCloseMarkCease () {
    this.setState({marksCeaseResults: {}})
  }

  onDeleteVehicle (data) {
    let vehiclesDeletes = {}
    vehiclesDeletes[data.id] = 'loading'
    this.setState({vehiclesDeleteResults: vehiclesDeletes})
    SostaOnlineApiService.deleteVehicle(data).then(result => {
      this.setState({vehiclesDeleteResults: {}})
      this.fetchUser()
    }).catch(err => {
      let vehiclesDeletes = {}
      vehiclesDeletes[data.id] = 'error'
      this.setState({vehiclesDeleteResults: vehiclesDeletes})
    })
  }

  onEditVehicleSubmit (data) {
    let vehiclesEdits = {}
    vehiclesEdits[data.id] = 'loading'
    this.setState({vehiclesEditsResults: vehiclesEdits})
    let obj = {
      id: data.id,
      plateNumber: data.plate_number,
      type: data.type
    }
    SostaOnlineApiService.updateVehicle(obj).then(result => {
      let vehiclesEdits = {}
      vehiclesEdits[data.id] = 'success'
      this.setState({vehiclesEditsResults: vehiclesEdits})
      // this.fetchUser();
    }).catch(err => {
      let vehiclesEdits = {}
      vehiclesEdits[data.id] = 'error'
      this.setState({vehiclesEditsResults: vehiclesEdits})
    })
  }

  onMarkSubmit (data) {
    let nowMoment = moment()
    // let toOneYearMoment = moment().add(1, 'y').subtract(1, 'days');
    // let expiration = moment().month(11).date(31);
    let expiration = moment().date(31).month(7).year(2018)
    this.setState({markLoading: true, markSuccess: false, markError: null})
    let obj = {
      issuedDate: nowMoment.format(),
      startDate: nowMoment.format(),
      endDate: expiration.format(),
      active: 1,
      userId: parseInt(this.state.userId),
      firstVehicleId: parseInt(data.firstVehicleId),
      secondVehicleId: parseInt(data.secondVehicleId),
      note: data.note,

      markTypeId: parseInt(data.markTypeId),
      categoryId: parseInt(data.categoryId.split('-')[1])
    }
    SostaOnlineApiService.createMark(obj).then(result => {
      this.setState({markLoading: false, markSuccess: true, markError: null})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nella creazione del contrassegno'
      if (err.error === 'Mark already exists') {
        error = 'Errore! Contrassegno già esistente!'
      }
      this.setState({markLoading: false, markSuccess: false, markError: error})
    })
  }

  onDeleteMark (data) {
    let marksDeletes = {}
    marksDeletes[data.id] = 'loading'
    this.setState({marksDeleteResults: marksDeletes})
    SostaOnlineApiService.deleteMark(data).then(result => {
      this.setState({marksDeleteResults: {}})
      this.fetchUser()
    }).catch(err => {
      let marksDeletes = {}
      marksDeletes[data.id] = 'error'
      this.setState({marksDeleteResults: marksDeletes})
    })
  }
  onCeaseMark (data) {
    let marksCease = {}
    marksCease[data.id] = 'loading'
    this.setState({marksCeaseResults: marksCease})
    SostaOnlineApiService.ceaseMark(data).then(result => {
      let marksCease = {}
      marksCease[data.id] = 'success'
      this.setState({marksCeaseResults: marksCease})
      this.fetchUser()
    }).catch(err => {
      let marksCease = {}
      marksCease[data.id] = 'error'
      this.setState({marksCeaseResults: marksCease})
    })
  }

  onParkingPassSubmit (data) {
    let startDateMoment = moment(data.startDate)
    let endDateMoment
    if (data.typeId === '2') {
      endDateMoment = moment(data.startDate).add(1, 'w')
    } else {
      endDateMoment = moment(data.startDate).add(30, 'days')
    }
    this.setState({parkTicketLoading: true, parkTicketSuccess: false, parkTicketError: null})
    let obj = {
      issuedDate: moment().format(),
      startDate: startDateMoment.format(),
      endDate: endDateMoment.format(),
      active: 1,
      userId: parseInt(this.state.userId),
      vehicleId: parseInt(data.vehicleId),
      note: data.note,
      markTypeId: data.markTypeId ? parseInt(data.markTypeId) : null,
      categoryId: parseInt(data.categoryId.split('-')[1]),
      parkTicketTypeId: data.typeId
    }
    SostaOnlineApiService.createParkTicket(obj).then(result => {
      this.setState({parkTicketLoading: false, parkTicketSuccess: true, parkTicketError: null})
      this.fetchUser()
    }).catch(err => {
      let error = "Errore nella creazione dell'abbonamento"
      if (err.error === 'ParkTicket already exists') {
        error = 'Errore! Abbonamento già esistente!'
      }
      this.setState({parkTicketLoading: false, parkTicketSuccess: false, parkTicketError: error})
    })
  }

  onCreateMarkUserCategorySelected (category) {
    let cat = category.target.value.split('-')[0]
    if (cat) {
      let area

      if (cat === 'resident') {
        area = this.state.user.residenceArea.code
      }

      if (cat === 'employees' ||
                cat === 'economy_activity_holder' ||
                cat === 'company_vehicles' ||
                cat === 'support_organizations' ||
                cat === 'accomodations_company') {
        area = this.state.user.workArea.code
      }

      SostaOnlineApiService
        .fetchMarkTypesByCategoryAndArea(cat.split('-')[0], area)
        .then(data => {
          this.setState({
            markTypes: data.data,
            loading: false
          })
        })
    } else {
      this.setState({
        markTypes: [],
        loading: false
      })
    }
  }

  onEditProfileClick () {
    this.props.history.push('/backoffice/users/' + this.state.userId + '/edit')
  }

  onDownloadParkTicket (parkTicket) {
    SostaOnlineApiService.downloadParkTicketMe(parkTicket.id).then(data => {
      fileDownload(data, 'abbonamento-' + parkTicket.issuedDate + '.pdf', 'application/pdf')
    })
  }

  onDownloadMark (mark) {
    SostaOnlineApiService.downloadMarkMe(mark.id).then(data => {
      fileDownload(data, 'contrassegno-' + mark.issuedDate + '.pdf', 'application/pdf')
    })
  }

  onDownloadMarkRelease (mark) {
    SostaOnlineApiService.downloadMarkReleaseMe(mark.id).then(data => {
      fileDownload(data, 'modulo-rilascio-contrassegno-' + mark.id + '.pdf', 'application/pdf')
    })
  }

  onDownloadUserCredentials (user) {
    SostaOnlineApiService.downloadUserCredentials(user.id).then(data => {
      fileDownload(data, 'credenziali-utente-' + user.id + '.pdf', 'application/pdf')
    })
  }

  onMarkReceiptDownload (markId) {
    SostaOnlineApiService.downloadMarkReceiptMe(markId).then(data => {
      fileDownload(data, 'ricevuta-contrassegno-' + markId + '.pdf', 'application/pdf')
    })
  }

  onReceiptDownload (parkTicketId) {
    SostaOnlineApiService.downloadReceiptMe(parkTicketId).then(data => {
      fileDownload(data, 'ricevuta-abbonamento-' + parkTicketId + '.pdf', 'application/pdf')
    })
  }

  onIssueReceipt (parkTicket) {
    this.setState({loading: true, error: null, receiptCreateSuccess: false, receiptCreateError: false})
    SostaOnlineApiService.fetchParkTicketType(parkTicket.parkTicketTypeId).then(parkType => {
      SostaOnlineApiService.createReceipt({ method: parkTicket.method, total: parkType.data.price, parkTicketId: parkTicket.id}).then(result => {
        this.setState({error: null, loading: false, receiptCreateSuccess: true, receiptCreateError: false})
        this.fetchUser()
      }).catch(err => {
        this.setState({error: 'Errore nella creazione della ricevuta', loading: false, receiptCreateError: true, receiptCreateSuccess: false})
      })
    })
  }

  async fetchAdjustment () {
    try {
      const res = await SostaOnlineApiService.fetchAdjustmentMe()
      console.log(res)
      this.setState({userAdjustment: res.data, loading: false})
    } catch (err) {
      console.error(err)
    }
  }

  async fetchMerger () {
    this.setState({...this.state, loading: true})
    try {
      const res = await SostaOnlineApiService.fetchMergerMe()
      this.setState({merger: res.data, loading: false})
    } catch (err) {
      console.error(err)
      this.setState({...this.state, loading: false})
    }
  }

  fetchUser () {
    this.setState({...this.state, loading: true})
    SostaOnlineApiService.fetchUserMe().then((data) => {
      // SostaOnlineApiService.fetchUserType(data.data.UserTypeId).then(userType => {
      this.setState({
        // userType : userType.data,
        user: data.data
        // loading: false
      }, () => {
        this.fetchAdjustment(data.data.fiscalCode, data.data.vatNumber)
        this.fetchMerger()
      })
    })
  }

  fetchParkTicketTypes () {
    SostaOnlineApiService.fetchParkTicketTypes().then((data) => {
      this.setState({
        parkTicketTypes: data.data,
        loading: false
      })
    })
  }

  fetchAreas () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchAreas().then((data) => {
      this.setState({
        areas: data.data,
        loading: false
      })
    })
  }

  fetchParkingPassTypes () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchParkingPassTypes().then((data) => {
      this.setState({
        parkingPassTypes: data.data,
        loading: false
      })
    })
  }

  async onRenewMark (mark) {
    console.log(mark)
    try {
      const response = await SostaOnlineApiService.renewMark({
        ...mark,
        action: 'RENEW'
      })
      await this.fetchUser()
      this.setState({showRenewMarkModal: false})
    } catch (e) {
      this.setState({
        renewErrors: 'Errore nel rinnovo del contrassegno, riprova più tardi.'
      })
    }
  }

  /* onCloseVehicleEdit () {
    this.setState({vehicleEditing: {}})
    this.props.onCloseVehicleEdit()
  } */

  onOpenRenewMarkModal (mark) {
    this.setState({
      renewingMark: mark,
      showRenewMarkModal: true
    })
  }

  onCloseRenewMarkModal () {
    this.setState({
      showRenewMarkModal: false,
      renewingMark: null
    })
  }

  onAdjustmentPay () {
    this.props.history.push('/user-area/pay/adjustment/' + this.state.userAdjustment.id)
  }

  async onMergeConfirm () {
    try {
      this.setState({merging: true})
      const res = await SostaOnlineApiService.acceptUserMerge()
      this.setState({merging: false})
      this.fetchUser()
    } catch (e) {
      this.setState({merging: false})
      console.error(e)
    }
  }

  async onMergeRefuse () {
    try {
      this.setState({merging: true})
      const res = await SostaOnlineApiService.denyUserMerge()
      this.setState({merging: false})
      this.fetchUser()
    } catch (e) {
      this.setState({merging: false})
      console.error(e)
    }
  }

  render () {
    const {
      renewErrors,
      renewingMark,
      showRenewMarkModal
    } = this.state

    if (this.state.loading) {
      return (<h2>Caricamento in corso...</h2>)
    }

    if (!this.state.user.id) {
      return (<h2>Errore! Utente non trovato</h2>)
    }

    return (<UserArea
      onAdjustmentPay={this.onAdjustmentPay}
      onDeleteVehicle={this.onDeleteVehicle.bind(this)}
      onVehicleSubmit={this.onVehicleSubmit.bind(this)}
      onCloseVehicleEdit={this.onCloseVehicleEdit.bind(this)}
      onEditVehicleSubmit={this.onEditVehicleSubmit.bind(this)}
      onMarkSubmit={this.onMarkSubmit.bind(this)}
      onDeleteMark={this.onDeleteMark.bind(this)}
      onCeaseMark={this.onCeaseMark.bind(this)}
      onCloseMarkCease={this.onCloseMarkCease.bind(this)}
      onParkingPassSubmit={this.onParkingPassSubmit.bind(this)}
      onCreateMarkUserCategorySelected={this.onCreateMarkUserCategorySelected.bind(this)}
      onDownloadParkTicket={this.onDownloadParkTicket.bind(this)}
      onDownloadMark={this.onDownloadMark.bind(this)}
      onDownloadMarkRelease={this.onDownloadMarkRelease.bind(this)}
      onDownloadUserCredentials={this.onDownloadUserCredentials.bind(this)}
      onReceiptDownload={this.onReceiptDownload.bind(this)}
      onMarkReceiptDownload={this.onMarkReceiptDownload.bind(this)}
      onIssueReceipt={this.onIssueReceipt.bind(this)}
      onEditProfileClick={this.onEditProfileClick.bind(this)}
      onOpenRenewMarkModal={this.onOpenRenewMarkModal}
      onCloseRenewMarkModal={this.onCloseRenewMarkModal}
      onCreateMarkClick={() => this.props.history.push('/user-area/marks/create')}
      onRenewMark={this.onRenewMark}
      parkingPassTypes={this.state.parkingPassTypes}
      parkTicketTypes={this.state.parkTicketTypes}
      user={this.state.user}
      areas={this.state.areas}
      userTypes={this.state.userTypes}
      markTypes={this.state.markTypes}
      userType={this.state.userType}
      vehicleLoading={this.state.vehicleLoading}
      vehicleSuccess={this.state.vehicleSuccess}
      vehicleError={this.state.vehicleError}
      markLoading={this.state.markLoading}
      markSuccess={this.state.markSuccess}
      markError={this.state.markError}
      parkTicketLoading={this.state.parkTicketLoading}
      parkTicketSuccess={this.state.parkTicketSuccess}
      parkTicketError={this.state.parkTicketError}
      receiptLoading={this.state.receiptLoading}
      receiptSuccess={this.state.receiptSuccess}
      receiptError={this.state.receiptError}
      vehiclesEditsResults={this.state.vehiclesEditsResults}
      vehiclesDeleteResults={this.state.vehiclesDeleteResults}
      markDeleteResults={this.state.marksDeleteResults}
      markCeaseResults={this.state.marksCeaseResults}
      renewErrors={renewErrors}
      renewingMark={renewingMark}
      showRenewMarkModal={showRenewMarkModal}
      userAdjustment={this.state.userAdjustment}
      merger={this.state.merger}
      merging={this.state.merging}
      onMergeRefuse={this.onMergeRefuse}
      onMergeConfirm={this.onMergeConfirm}
    />)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAreaContainer)



// WEBPACK FOOTER //
// ./src/containers/UserArea/UserAreaContainer.js